import maplibregl from 'maplibre-gl'

export default class CustomNavigationControl extends maplibregl.NavigationControl {
  onAdd(map) {
    this._map = map
    this._container = super.onAdd(map)

    // Find the compass element and override its click event
    const compass = this._container.querySelector('.maplibregl-ctrl-compass')
    if (compass) {
      compass.title = 'Reset bearing and tilt'
      compass.addEventListener('click', this._onCompassClick.bind(this))
    }

    return this._container
  }

  _onCompassClick() {
    // Set the bearing and pitch to 0
    this._map.easeTo({ bearing: 0, pitch: 0 })
  }
}
